module.exports = __webpack_public_path__ + "assets/img/JPMorgan.dcbc514c.png";